


window.addEventListener('load', () => {
    const response = fetch(`/products/${handle}`);

    response.then((response) => {
        // return html response
        return response.text();
    }).then((product) => {
        let productTemplate = product.split('<!-- split -->')[1].split('<!-- end split -->')[0];
        console.log(productTemplate);
        document.querySelector('.article-product-form__product').innerHTML = productTemplate;
    }).then(() => {
        document.querySelector('product-template').init();
        document.querySelector('product-template').classList.remove('page-width');
        document.querySelector('.product-media .reassurance__container').classList.add('hidden');
        if (document.querySelector('[data-subscription-template]')) {

        } else {
            if (document.querySelector('[for="CustoRcOs"]')) {
                document.querySelector('[for="CustoRcOs"]').click();
            }
        }

        document.querySelectorAll('[data-scroll-to-form]').forEach((button) => {
            button.addEventListener('click', () => {

                let scrollTop = document.querySelector('.product-form').getBoundingClientRect().top - document.body.getBoundingClientRect().top - 80;
                window.scrollTo({ top: scrollTop, left: 0, behavior: 'smooth' });
            });
        });
    });
});

function SelectProductToAddToCart() {
    const form_input = document.getElementById('product-form').querySelector('input[name="id"]');
    const RC_input = document.getElementById('customAbo');
    const RC_selling_plan = document.getElementById('CustoRcAboSellingPlan');
    let hasSubscription = false;
    if (document.querySelector('[data-subscription-template]')) {
        hasSubscription = true;
    }
    if (hasSubscription) {
        if (RC_input && RC_input.checked) {
            console.log('Abo');
            mmAddProductRCToCart(form_input.value, RC_selling_plan.value);
        } else {
            console.log('OS');
            mmAddProductToCart(form_input.value);
        }
    } else {
        mmAddProductToCart(form_input.value);
    }


}

// FORM
class VariantSelector extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('change', this.onVariantChange);
        this.hasSubscription = false;
        if (document.querySelector('[data-subscription-template]')) {
            this.hasSubscription = true;
        }
    }

    onVariantChange() {
        this.getSelectedOptions();
        this.getSelectedVariant();


        if (this.currentVariant) {
            this.updateURL();
            this.updateFormID();
            this.updatePrices();
            this.updateCTA();
        }
    }

    getSelectedOptions() {
        this.options = Array.from(this.querySelectorAll('.variant-selector__option-checkbox:checked'), (checkbox) => checkbox.value);
    }

    getVariantJSON() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    getSelectedVariant() {
        this.currentVariant = this.getVariantJSON().find(
            (variant) => {
                const findings = !variant.options.map(
                    (option, index) => {
                        return this.options[index] === option;
                    }
                ).includes(false);

                if (findings) return variant;
            }
        );
    }

    updateURL() {
        if (!this.currentVariant) return;
    }

    updateFormID() {
        const form_input = document.querySelector('#product-form').querySelector('input[name="id"]');
        form_input.value = this.currentVariant.id;
    }

    updatePrices() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `[data-sub-new-price]`;
                const idOS = `rcOSPrice`;
                const idCTA = `btn-price-input`;
                const idCTA2 = `btn-price-input-2`;
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const RCcheckedInput = document.querySelector('.custom-rc:checked + label [data-good-price]');


                const oldPrice = document.querySelector(id);
                const newPrice = this.currentVariant.selling_plan_allocations[0].price;
                const oldPriceOS = document.getElementById(idOS);
                const newPriceOS = html.getElementById(idOS);
                const oldPriceCTA = document.getElementById(idCTA);
                const newPriceCTA = html.getElementById(idCTA);
                const oldPriceCTA2 = document.getElementById(idCTA2);

                if (document.querySelector('[data-sub-old-price]')) {
                    document.querySelector('[data-sub-old-price]').textContent = (this.currentVariant.price / 100).toFixed(2) + "€"
                }



                if (this.hasSubscription) {
                    if (oldPrice && newPrice) oldPrice.innerHTML = (newPrice / 100) + "€";
                }

                if (oldPriceOS && newPriceOS) oldPriceOS.innerHTML = newPriceOS.innerHTML;

                if (this.hasSubscription) {
                    if (oldPriceCTA) oldPriceCTA.innerHTML = RCcheckedInput.innerHTML.replace('€', '');
                } else {
                    if (oldPriceCTA && newPriceCTA) oldPriceCTA.innerHTML = newPriceCTA.innerHTML;
                }
                if (this.hasSubscription) {
                    if (oldPriceCTA) oldPriceCTA2.innerHTML = RCcheckedInput.innerHTML.replace('€', '');
                } else {
                    if (oldPriceCTA && newPriceCTA) oldPriceCTA2.innerHTML = newPriceCTA.innerHTML;
                }

                let divider = document.querySelector('input:checked + label [data-divider-unit]').dataset.dividerUnit;

                let unitPrice = (this.currentVariant.price / 100) / divider;
                let unitPriceAbo = (this.currentVariant.selling_plan_allocations[0].price / 100) / divider;

                document.querySelector('.subscription--os  [data-unit-price]').textContent = unitPrice.toFixed(2) + "€";
                document.querySelector('.subscription--abo [data-unit-price]').textContent = unitPriceAbo.toFixed(2) + "€";
                document.querySelector('product-template').initProductForm();
            })
    }

    updateCTA() {
        const CTA = document.querySelector('.product-form-submit-button');
        if (this.currentVariant.available) {
            CTA.classList.remove('mm-btn-disabled');
        } else {
            CTA.classList.add('mm-btn-disabled');
        }
    }
}

customElements.define('variant-selector', VariantSelector);
